import "./AcceptInvite.css";
import { ACCEPT_INVITE } from "../../api";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { useHistory, useParams } from "react-router-dom";

export default function AcceptInvite() {
  const history = useHistory();
  const { token } = useParams();
  // console.log("TOKEN:", token);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [acceptInvite, { loading }] = useMutation(ACCEPT_INVITE, {
    onError: (e) => {
      console.log(e.message);
      setError(e.message);
    },
    update: (cache, { data: { acceptAdminInvite } }) => {
      if (!acceptAdminInvite.token || !acceptAdminInvite.expiresAt) {
        setError(
          "Something went wrong. Please check your internet connection and try again."
        );
        return;
      }

      localStorage.setItem("hola-auth-token", acceptAdminInvite.token);
      localStorage.setItem("hola-expires-at", acceptAdminInvite.expiresAt);

      history.push("/dashboard");
    },
  });

  return (
    <div className="Login">
      <div className="Login__brand">
        <img src={"/logo-black.svg"} />
      </div>

      <form
        className="Login__form"
        onSubmit={(e) => {
          e.preventDefault();

          if (loading) {
            return;
          }

          setError("");

          if (!token) {
            setError(
              "Your invite token is incorrect or expired. Please contact the administrator to generate a new token. "
            );
            return;
          }

          if (!password) {
            setError("A password is required.");
            return;
          }

          acceptInvite({ variables: { token, password } });
        }}
      >
        <div className="Login__form__group">
          <div className="Login__form__group__label">Set Password</div>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setError("");
              setPassword(e.target.value);
            }}
            className="Login__form__group__input"
          />
        </div>

        {error && <div className="Login__form__error">{error}</div>}

        <button
          type="submit"
          className={"Login__form__submit " + (loading ? "disabled" : "")}
        >
          Login
        </button>
      </form>
    </div>
  );
}
